import { PercentageOutlined } from "@ant-design/icons";
import { Col, Form, Row } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import MazakaInputNumber from "apps/Common/MazakaInputNumber";
import { MazakaRangePicker } from "apps/Common/MazakaRangePicker";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import useMazakaForm from "hooks/useMazakaForm";
import { useSearchParams } from "react-router-dom";
import { useGetContractDetails } from "../../ServerSideStates";
import { useEffect, useState } from "react";
import FormatThousandsNumber from "apps/Common/FormatThousandsNumber";
import dayjs from "dayjs";
import { editContract } from "../../Services";
import GeneralCurrencies from "apps/Common/Currency/GeneralCurrencies";

const RentalInfoes = (props: any) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const [searchParams,setSearchParams] = useSearchParams();
  const contractId = searchParams.get("contractId");
  const [selectedPaymentType,setSelectedPaymentType] = useState<number>(7)
 
  const contractDetails = useGetContractDetails(contractId || "");
  const paymentTypeOptions = [
    {label:"Peşin",value:0},
    {label:"Taksit",value:1},
    {label:"Sözleşmede Belirtildiği Şekilde",value:2},
  ]

  useEffect(() => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("key", "rentalInfoes");
      return newParams;
    });
  }, []);
  useEffect(() => {
    if (contractDetails?.data?.data) {
      let contractData = contractDetails?.data?.data
      const startDate = contractData["startDate"]
      ? dayjs(contractData["startDate"])
      : null;
    const endDate = contractData["endDate"]
      ? dayjs(contractData["endDate"])
      : null;
    const dateRange = startDate && endDate ? [startDate, endDate] : [];
    contractData["date"] = dateRange
      form.setFieldsValue({
        ...contractData
      });
     setSelectedPaymentType(contractData?.paymentType)
   
    }
  }, [contractDetails.data]);
  function parseValue(value:number|string) {
    return typeof value === "string" ? parseFloat(value.replace(/,/g, '')) : value;
}
  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    let formValues = form.getFieldsValue();
  

  
  formValues["deposit"] = parseValue(formValues["deposit"]) || 0;
  formValues["downPayment"] = parseValue(formValues["downPayment"]) || 0;
  formValues["monthlyRentalFee"] = parseValue(formValues["monthlyRentalFee"]);
  formValues["annualRentalFee"] = parseValue(formValues["annualRentalFee"]);
   
    formValues["startDate"] = dayjs(formValues["date"][0]).format("YYYY-MM-DD");
    formValues["endDate"] = dayjs(formValues["date"][1]).format("YYYY-MM-DD");
    delete formValues["date"];
    let contractData = contractDetails?.data?.data;
    try {
      const response:any = await editContract({...contractData,...formValues})
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set("contractId", response?.data?.id);
        return newParams;
      });
      mazakaForm.setSuccess(2000, () => "İşlem Başarılı");
      props.setSelectedKey("generalConditions")
      
    } catch (error: any) {
      mazakaForm.setFailed(2000, error?.message);
    }
  };


  return (
    <>
      <Col span={24}>
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          onFinish={handleOnFinish}
        >
          <Row gutter={[10, 20]} className="">
            <MazakaRangePicker
            disablePastDates={true}
              xs={24}
              md={12}
              lg={6}
              name={"date"}
              label={"Tarih Aralığı"}
              className="!m-0"
              rules={[{ required: true, message: "" }]}
            />
            <GeneralCurrencies
              xs={24}
              md={12}
              lg={6}
              name={"currencyId"}
              label={"Para Birimi"}
              className="!m-0"
              placeholder={"Fiyat"}
              rules={[{ required: true, message: "" }]}
              
            />
             <FormatThousandsNumber
             
              formattedInputNumber={true}
              xs={24}
              md={12}
              lg={6}
              form={form}
              name={"monthlyRentalFee"}
              label={"Aylık Kira Bedeli"}
             
              placeholder={"Fiyat"}
              className="!m-0"
              rules={[{ required: true, message: "" }]}
              onInputNumberChange={(value:any)=>{
             
              
               
                if(value)
                {
                 
                  let total = value*12
                  form.setFieldValue("annualRentalFee",total)
                }
                else{
                  form.setFieldValue("annualRentalFee",0)
                }
              }}
              
            />

<FormatThousandsNumber
             
             formattedInputNumber={true}
            
             form={form}
             xs={24}
             md={12}
             disabled={true}
             lg={6}
             name={"annualRentalFee"}
             label={"Yıllık Kira Bedeli"}
             className="!m-0"
             rules={[{ required: true, message: "" }]}
             placeholder={"Yıllık Kira Bedeli"}
             
             
           />




            
            <MazakaInputNumber
              xs={24}
              
              name={"increaseRate"}
              label={"Artış Oranı"}
              className="!m-0"
              prefix={<PercentageOutlined />}
              rules={[{ required: true, message: "" }]}
              placeholder={"Artış Oranı"}
            />
            <MazakaSelect
              name={"paymentType"}
              label="Ödeme Şekli"
              placeholder="Ödeme Şekli"
              xs={24}
              className="!m-0"
              rules={[{ required: true, message: "" }]}
              options={paymentTypeOptions}
              onChange={(value:number)=>{
                setSelectedPaymentType(value)
              }}
            />
            {
              selectedPaymentType===0&&
              <>
              <FormatThousandsNumber
              
                name={"downPayment"}
                label={"Peşinat"}
                
                placeholder={"Peşinat"}

                formattedInputNumber={true}
              xs={24}
              
              form={form}
              
              className="!m-0"
              rules={[{ required: true, message: "" }]}
              />
              
              </>
            }
            <FormatThousandsNumber
             name={"deposit"}
             label={"Depozito"}
             placeholder={"Peşinat"}

             formattedInputNumber={true}
           xs={24}
           
           form={form}
           
           className="!m-0"
         
              
            />
           

            <Col span={24}>
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                block
                processType={formActions.submitProcessType}
              >
                Kaydet ve Devam Et
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default RentalInfoes;
